import React from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';

import { DEFAULT_GRID_CONTAINER_SPACING, } from 'common/constants';
import {
    FiltersPanel,
    FiltersMobileView,
    ProductsList,
    ProductInfoBar,
    ProductsFilterBar,
    ProductsPaginationBar,
} from './components';

const Products = () => {
    return (
        <Grid container
              spacing={DEFAULT_GRID_CONTAINER_SPACING}>
            <Hidden smDown>
                <Grid item
                      md={3}>
                    <FiltersPanel />
                </Grid>
            </Hidden>
            <Grid item
                  md={9}
                  sm={12}>
                <ProductInfoBar />
                <FiltersMobileView />
                <Box mt={1}>
                    <ProductsFilterBar />
                </Box>
                <ProductsList />
                <ProductsPaginationBar />
            </Grid>
        </Grid>
    );
};

export default Products;
